import logo from './logo.svg';
import './App.css';
import Homepage from './containers/homePage';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Navbar } from './components/navbar';
import Home from './pages/home';
import About from './pages/aboutus'
import WebDesign from './pages/webdesign';
import HomePage from './containers/homePage'
import Graphics from './pages/graphics';
import Contacts from './pages/contacts';



function App() {
  return <div> 
            <Router>
        <Switch>
          <Route path='/' exact component={Home}  />
          <Route path='/home' exact component={Home}  />
          <Route path='/about-us' exact component={About}/>
          <Route path='/web-design' exact component={WebDesign}/>
          <Route path='/graphics' exact component={Graphics}/>
          <Route path='/contacts' exact component={Contacts}/>

        </Switch>
     </Router>
                  {/* <Navbar /> */}
      {/* <HomePage /> */}
        </div> 
}

export default App;
